import { useAuthContext } from "../common/AuthContext";
import { Route, Redirect, RouteProps, useHistory } from "react-router-dom";
import { useDataTransfer, useNoop } from "../common/services/generalServices";
import { Grid, LinearProgress, useTheme } from "@material-ui/core";
import { useGlobalLogout } from "../common/util";
import { toast } from "react-toastify";
import { Warning } from "@material-ui/icons";
import { WarningPage } from "../../plchina/WarningPage";
export const PrivateRoute = ({ component: Component, ...rest }: RouteProps) => {
  const { isAuthenticated } = useAuthContext();
  const theme = useTheme();
  const history = useHistory();

  const { logout } = useGlobalLogout();

  const {
    data: noopData,
    error: errorNoop,
    isLoading: isLoadingNoop,
    isSuccess: isSuccessNoop,
    isError: isErrorNoop,
  } = useNoop(localStorage.getItem("token"));


  const {
    data: dataTransfer,
    error: dataTransferError,
    isLoading: dataTransferLoading,
    isSuccess: dataTransferSuccess,
    isError: dataTransferisError,
  } = useDataTransfer();

  if (isLoadingNoop) {
    return (
      <div style={theme.containerMargin}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={4}
        >
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (isErrorNoop) {
    toast.error(`Error on your session.Please log in again.${errorNoop}`);
    logout();
    return (
      <Redirect to={{ pathname: "/", state: { from: history.location } }} />
    );
  }


  if (dataTransferSuccess) {
    localStorage.setItem("cron_status", dataTransfer.status.toString());
    localStorage.setItem("cron_datetime", dataTransfer.datetime);
  } else if (dataTransferisError) {
    localStorage.setItem("cron_status", false.toString());
    localStorage.setItem("cron_datetime", false.toString());
  }

  if (!Component) return null;

  if (dataTransfer == true && localStorage.getItem("theme") == "2") {
    return (
      <WarningPage></WarningPage>
    )
  } else {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (isAuthenticated()) {
            return <Component {...props} />;
          }
          logout();
          return (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }}
      />
    );
  }
  ;

  // return (
  //   <Route
  //     {...rest}
  //     render={(props) => {
  //       if (isAuthenticated()) {
  //         return <Component {...props} />;
  //       }
  //       logout();
  //       return (
  //         <Redirect to={{ pathname: "/", state: { from: props.location } }} />
  //       );
  //     }}
  //   />
  // );
};
